// extracted by mini-css-extract-plugin
export default {"section":"pF4Hln","container":"hsdGoi","button":"lRCMeh","cardsGrid":"Dw5LEF","topLeftCard":"l1Lk4_","topRightCard":"aXBecs","bottomLeftCard":"keyd1h","bottomRightCard":"PsTivX"};